import React, { createContext, useState, useContext, useRef } from "react";

const VideoContext = createContext<any>(null);

   export const pageStyles = `
    .video-page-shell,
    .video-page-shell * {
      box-sizing: border-box;
    }
    
    .video-page-shell {
      width: 100%;
      min-height: 100vh;
      overflow-x: hidden;
      background: #fff6e1;
      margin-top: -50px;
    }
    
    .video-page-container {
      width: 100%;
      max-width: 1200px;
      margin: 0 auto;
    }
    
    .video-page-layout {
      display: grid;
      grid-template-columns: minmax(0, 1fr) minmax(330px, 380px);
      gap: clamp(24px, 2vw, 32px);
      align-items: start;
      width: 100%;
    }
    
    .video-main-column {
      min-width: 0;
    }
    
    .video-player-card {
      width: 100%;
      border-radius: 12px;
      border: 1px solid #ead7b1;
      background: #fffaf0;
    }
    
    .video-player-card .card-body {
      padding: 10px;
    }
    
    .video-frame {
      position: relative;
      width: 100%;
      aspect-ratio: 128 / 72;
      overflow: hidden;
      border-radius: 8px;
      max-width: 900px;
      background: #120008;
    }
    
    .video-frame > div,
    .video-frame iframe,
    .video-frame .youtube-frame {
      width: 100% !important;
      height: 100% !important;
      display: block;
    }
    
    .video-thumb {
      width: 100%;
      aspect-ratio: 16 / 9;
      object-fit: cover;
      display: block;
      border-radius: 8px;
      cursor: pointer;
    }
    
    .video-title {
      display: block !important;
      white-space: nowrap !important;
      overflow: visible !important;
      text-overflow: clip !important;
      width: 100% !important;
      max-width: none !important;
      font-size: 25px !important;
      padding-top: 10px;
    }
    
    .video-meta-row {
      display: flex;
      gap: 14px;
      flex-wrap: wrap;
      align-items: center;
      color: #777;
      font-size: 14px;
      margin-top: 12px;
    }
    
    .video-description-card {
      width: 100%;
      margin-top: 20px;
      border-radius: 12px;
      border: 1px solid #ead7b1;
    }
    
    .related-card {
      height:735px;
      width: 100%;
      border-radius: 12px;
      border: 1px solid #ead7b1;
      background: #fffaf0;
      overflow-y: auto;
      scrollbar-width: thin;
      scrollbar-color: #d4b483 transparent;
    }
    
    .related-card::-webkit-scrollbar,
    .related-list::-webkit-scrollbar {
      width: 2px;
    }
    
    .related-card::-webkit-scrollbar-track,
    .related-list::-webkit-scrollbar-track {
      background: transparent;
    }
    
    .related-card::-webkit-scrollbar-thumb,
    .related-list::-webkit-scrollbar-thumb {
      background: #d4b483;
      border-radius: 20px;
    }
    
    .related-title {
      color: #d56b1f;
      font-weight: 600;
      margin-bottom: 18px;
    }
    
    .related-list {
      max-height: calc(100vh - 230px);
      overflow-y: auto;
      scrollbar-width: thin;
      scrollbar-color: #f0e3d9 transparent;
    }
    
    .related-item {
      display: flex;
      gap: 12px;
      margin-bottom: 16px;
      cursor: pointer;
      min-width: 0;
    }
    
    .related-thumb {
      width: clamp(118px, 7.5vw, 145px);
      aspect-ratio: 16 / 9;
      border-radius: 8px;
      object-fit: cover;
      flex: 0 0 auto;
    }
    
    .related-copy {
      min-width: 0;
    }
    
    .related-video-title {
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      color: #333;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    
    .empty-related-text {
      color: #777;
      font-size: 14px;
    }
    
    @media (max-width: 1199.98px) {
      .video-page-layout {
        grid-template-columns: minmax(0, 1fr) minmax(300px, 360px);
      }
    }
    
    @media (max-width: 991.98px) {
      .video-page-shell {
        margin-top: -30px;
        padding-top: 32px;
      }
    
      .video-page-layout {
        grid-template-columns: 1fr;
      }
    
      .related-list {
        max-height: none;
        overflow: visible;
      }
    }
    
    @media (max-width: 575.98px) {
      .video-page-shell {
        padding: 24px 14px;
      }
    
      .related-item {
        gap: 10px;
      }
    
      .related-thumb {
        width: 118px;
      }
    }
    `;

export const VideoProvider = ({ children }: { children: React.ReactNode }) => {
  const [open, setOpen] = useState(false);
  const [isPiP, setIsPiP] = useState(false);
  const [videoId, setVideoId] = useState("");
  const [youtubeTitle, setYoutubetitle] = useState("");
  const [options, setOptions] = useState<any>({});
  const [isLiked, setIsLiked] = useState(false);
  const [likedMsg, setLikedMsg] = useState(null);
  const [gitasevalogo, setGitasevalogo] = useState("");
  const [playbackTime, setPlaybackTime] = useState(0);
  const [videoObjId, setVideoObjId] = useState<any>();
  const [playingVideo,setPlayingVideo]=useState<boolean>(false);
  type MediaType = 'none' | 'audio' | 'video';
  const [activeMedia, setActiveMedia] = useState<MediaType>('none');
    const refVideo:any=useRef(null);

      const playerRef = useRef(null); // YouTube वीडियो प्लेयर के लिए
  const audioPlayerRef = useRef(null); // HTML <audio> एलिमेंट के लिए
  // const{refAudio}=useAudio()
    const refAudio = useRef<any>(null);

    
  return (
    <VideoContext.Provider
      value={{
        open,
        setOpen,
        isPiP,
        setIsPiP,
        videoId,
        setVideoId,
        youtubeTitle,
        setYoutubetitle,
        options,
        setOptions,
        isLiked,
        setIsLiked,
        likedMsg,
        setLikedMsg,
        gitasevalogo,
        setGitasevalogo,
        playbackTime,
        setPlaybackTime,
        videoObjId,
        setVideoObjId,
        refVideo,
        playingVideo,
        setPlayingVideo,
        activeMedia,
        setActiveMedia,
        playerRef,
        audioPlayerRef
      }}
    >
      {children}
    </VideoContext.Provider>
  );
};

export const useVideo = () => useContext(VideoContext);
